import { loadResourcesUtils } from "./LoadResourcesUtils.js";
export {
  loadResourcesUtils
};
//# sourceMappingURL=index.js.map
